/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { kioskKeepAlive } from '../fn/kiosk/kiosk-keep-alive';
import { KioskKeepAlive$Params } from '../fn/kiosk/kiosk-keep-alive';

@Injectable({ providedIn: 'root' })
export class KioskService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `kioskKeepAlive()` */
  static readonly KioskKeepAlivePath = '/v1/Kiosk/KeepAlive';

  /**
   * Keep alive for kiosk : Update LastMonitorDate by kioskId,   Permissions [AuthenticatedUser|LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `kioskKeepAlive()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  kioskKeepAlive$Response(params?: KioskKeepAlive$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return kioskKeepAlive(this.http, this.rootUrl, params, context);
  }

  /**
   * Keep alive for kiosk : Update LastMonitorDate by kioskId,   Permissions [AuthenticatedUser|LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `kioskKeepAlive$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  kioskKeepAlive(params?: KioskKeepAlive$Params, context?: HttpContext): Observable<void> {
    return this.kioskKeepAlive$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
